import { Injectable } from '@angular/core';

@Injectable()
export class CalendarStatisticService {

  private _backref = '/calendar/statistic';

  set backref(value) {
    this._backref = value;
  }

  get backref() {
    return this._backref;
  }

  constructor() {
  }
}
